import { shuttleRiders } from '@/endpoint.flexigo';
import Repository from './repository';

const client = new Repository();
const blobClient = new Repository({ responseType: 'blob' });

// The commute backend expects these list endpoint arrays as comma-delimited
// values (e.g. routeGroups=1,2,3), but Axios defaults to bracket syntax
// (routeGroups[]=1&routeGroups[]=2), which the BE rejects with 400.
function toCommaDelimited(values) {
  return values.join(',');
}

// Axios URL-encodes commas as %2C; the backend expects the raw ',' separator,
// so we serialize query params ourselves and leave commas unencoded.
function commaDelimitedParamsSerializer(params) {
  return Object.entries(params)
    .map(([key, value]) => {
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(value).replace(/%2C/g, ',');
      return `${encodedKey}=${encodedValue}`;
    })
    .join('&');
}

export default {
  async listAssociations({ companyIds, departments, routeGroups, schedules } = {}) {
    const params = {};
    if (companyIds?.length) params.companyIds = toCommaDelimited(companyIds);
    if (departments?.length) params.departments = toCommaDelimited(departments);
    if (routeGroups?.length) params.routeGroups = toCommaDelimited(routeGroups);
    if (schedules?.length) params.schedules = toCommaDelimited(schedules);

    const r = await client.get(shuttleRiders.listAssociations, params, false, {
      paramsSerializer: commaDelimitedParamsSerializer,
    });
    return r;
  },

  async listAssignments({ startDay, endDay, departments, routeGroups, schedules } = {}) {
    const params = {};
    if (startDay !== undefined && startDay !== null) params.startDay = startDay;
    if (endDay !== undefined && endDay !== null) params.endDay = endDay;
    if (departments?.length) params.departments = toCommaDelimited(departments);
    if (routeGroups?.length) params.routeGroups = toCommaDelimited(routeGroups);
    if (schedules?.length) params.schedules = toCommaDelimited(schedules);

    const r = await client.get(shuttleRiders.listAssignments, params, false, {
      paramsSerializer: commaDelimitedParamsSerializer,
    });
    return r;
  },

  async deleteAssignments(assignments) {
    const r = await client.post(shuttleRiders.deleteAssignments, assignments);
    return r;
  },

  async assignPersonnels(payload) {
    const r = await client.post(shuttleRiders.assignPersonnels, payload);
    return r;
  },

  async suggest(payload) {
    const r = await client.post(shuttleRiders.suggest, payload);
    return r;
  },

  async uploadAssignments(file) {
    const formData = new FormData();
    formData.append('file', file);
    const r = await client.post(shuttleRiders.uploadAssignments, formData);
    return r;
  },

  async downloadAssignmentsTemplate(lang = 'tr') {
    const r = await blobClient.get(`${shuttleRiders.downloadAssignmentsTemplate}?lang=${lang}`);
    return r;
  },
};
